export type HeightOfWidthProps = {
    children: React.ReactNode;
    ratio?: number;
}

export default function HeightOfWidth({ children, ratio = 1 }: HeightOfWidthProps) {
    return (
        <div className="w-full relative" style={{ paddingTop: `${100 * ratio}%` }}>
            <div className="absolute left-0 right-0 top-0 bottom-0">{children}</div>
        </div>
    );
}